"use client";

import React from "react";
import TireCodeBlock from "./TireCodeBlock";
import { useTireReading } from "@/app/context/TireReadingContext";

const BlockGrid: React.FC = () => {
  const { codes, misreadWarning } = useTireReading();

  return (
    <>
      <div className="grid w-[100%] grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-6 h-auto auto-rows-max mb-auto items-start">
        {codes.map((code) => (
          <TireCodeBlock key={code} code={code} />
        ))}
      </div>
      {misreadWarning && (
        <div className="fixed top-6 right-6 bg-red-500 text-white text-3xl px-4 py-2 rounded-xl shadow-lg z-50">
          Waarschuwing: De machine heeft deze band mogelijk verkeerd gelezen.
        </div>
      )}
    </>
  );
};

export default BlockGrid;
